(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-content"]) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'chandravastra_wishlist';

    function getWishlist() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : [];
      } catch (err) {
        return [];
      }
    }

    function setWishlist(list) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      } catch (err) {}
    }

    function formatMoney(cents) {
      return '\u20b9' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 });
    }

    function removeFromWishlist(handle) {
      var list = getWishlist().filter(function (h) { return h !== handle; });
      setWishlist(list);
      render();
    }

    function renderEmptyState(root) {
      var emptyText = root.getAttribute('data-empty-text');
      var emptyButtonText = root.getAttribute('data-empty-button-text');
      var emptyLink = root.getAttribute('data-empty-link');
      root.innerHTML =
        '<div class="wishlist-page__empty">' +
        '<p>' + emptyText + '</p>' +
        '<a href="' + emptyLink + '" class="button">' + emptyButtonText + '</a>' +
        '</div>';
    }

    function render() {
      var root = document.getElementById('wishlist-root');
      if (!root) return;
      var handles = getWishlist();

      if (!handles.length) {
        renderEmptyState(root);
        return;
      }

      // Own the container fully while data loads, then replace with the grid.
      // This avoids ever showing a stale empty-state alongside newly loaded items.
      Promise.all(
        handles.map(function (handle) {
          return fetch('/products/' + handle + '.js')
            .then(function (res) { return res.ok ? res.json() : null; })
            .catch(function () { return null; });
        })
      ).then(function (products) {
        // Re-check current wishlist state in case it changed while fetching
        var currentHandles = getWishlist();
        if (!currentHandles.length) {
          renderEmptyState(root);
          return;
        }

        var cardsHtml = '';
        products.forEach(function (product, i) {
          if (!product) return;
          var handle = handles[i];
          var image = product.featured_image || (product.images && product.images[0]);
          cardsHtml +=
            '<div class="wishlist-page__card">' +
            '<button class="wishlist-page__remove" data-handle="' + handle + '" aria-label="Remove">\u00d7</button>' +
            '<a href="/products/' + handle + '">' +
            (image ? '<img src="' + image + '" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
            '</a>' +
            '<p class="wishlist-page__card-title"><a href="/products/' + handle + '">' + product.title + '</a></p>' +
            '<p class="wishlist-page__card-price">' + formatMoney(product.price) + '</p>' +
            '</div>';
        });

        if (!cardsHtml) {
          renderEmptyState(root);
          return;
        }

        root.innerHTML = '<div class="wishlist-page__grid">' + cardsHtml + '</div>';
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.wishlist-page__remove');
      if (!btn) return;
      removeFromWishlist(btn.getAttribute('data-handle'));
    });

    render();
  })();

  } catch(e) { console.error(e); }
})();
})();
